export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/LayoutWorker.worker.e0559ab6.worker.js");
}
